// @core/api/endpoints/resource/update_resource_link.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResourceLinkResponse,
  UpdateResourceLinkRequest,
} from '../../../types/resource';

const BASE_PATH = '/resource';

/**
 * Update a resource link
 * Updates properties of an existing link between two resources, such as the relation type, label, note, or metadata.
 */
export async function UpdateResourceLink(
  link_id: string,
  data: UpdateResourceLinkRequest,
  options?: RequestOptions
): Promise<ResourceLinkResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/links/:link_id`;
  requestPath = requestPath.replace(':link_id', encodeURIComponent(link_id));
  const requestOptions = options;
  return client.patch<ResourceLinkResponse>(requestPath, data, requestOptions);
}
